import {
	Component,
	OnDestroy,
	EventEmitter,
	Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'm-header-search',
	templateUrl: './header-search.component.html',
	styleUrls: ['./header-search.component.scss'],
})
export class HeaderSearchComponent implements OnDestroy {
	formControlFiltro = new FormControl();
	destroy$ = new EventEmitter();
	@Output() onValueChange = this.formControlFiltro.valueChanges.pipe(takeUntil(this.destroy$));

	ngOnDestroy(): void {
		this.destroy$.next(true);
		this.destroy$.complete();
	}

	limparPesquisa() {
		this.formControlFiltro.setValue('');
	}
}
